<script setup lang="ts">
import type { PeriodRemainProps } from '@/types/appTypes'

const props = withDefaults(defineProps<PeriodRemainProps>(), {
  termFrom: null,
  termTo: null,
  small: false,
  hideDayCount: false,
})

const app = useNuxtApp()

const timeRemain = computed(() => {
  if (props.hideDayCount) return null
  return app.$getPeriodRemain(props.termFrom, props.termTo)
})
</script>

<template>
  <div
    v-if="timeRemain"
    class="c-periodRemain"
    v-bind:class="[timeRemain.type, { 'is-small': small }]"
  >
    <!--
    <span class="c-periodRemain_icon"></span>
    -->
    {{ timeRemain.label }}
  </div>
</template>

<style lang="scss" scoped>
.c-periodRemain {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.5;

  &_icon {
    display: inline-block;
    position: relative;
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border: 1px solid #c8c8c8;
    border-radius: 50%;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 8px;
      height: 8px;
      margin: auto;
      border-radius: 50%;
      background-color: #000;
    }
  }

  &.is-small {
    font-size: 12px;
  }

  &.is-small & {
    &_icon {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
  }

  &.in {
    color: #00a23f;
  }

  &.in &_icon::before {
    background-color: #00a23f;
  }

  &.soonEnd {
    color: #c20000;
  }

  &.soonEnd &_icon::before {
    background-color: #c20000;
  }

  &.todayEnd {
    color: #c20000;
  }

  &.todayEnd &_icon::before {
    background-color: #c20000;
  }

  &.toGo {
    color: #000;
  }

  &.toGo &_icon::before {
    background-color: #000;
  }

  &.end {
    color: #7d7d7d;
  }

  &.end &_icon::before {
    background-color: #7d7d7d;
  }
}
</style>
